module.exports = __webpack_public_path__ + "2767cd972607ba3e256e92d0e103ed47.png";